(function () {
  'use strict';

  angular.module('wsLrs.services').factory('Analytics', ['Api', '$http', 'DefaultCardGroups', 'User', '$location', '$window', 'Utils', 'Config', 'UserRoles', '$q', 'OrganizationSettings', '$document', 'TinCanJS', 'Logger', function (Api, $http, DefaultCardGroups, User, $location, $window, Utils, Config, UserRoles, $q, OrganizationSettings, $document, TinCanJS, Logger) {
    var res = {
      cardViewed: function cardVieved(cardId, template) {
        $http({
          method: 'POST',
          url: Api.url("analytics/card-view", true),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: $.param({
            cardId: cardId,
            template: template
          })
        }).catch(function (err) {
          var message = 'An unrecognized error has occurred. Details have been logged.';
          if (err.data) {
            if (err.data.message) {
              message = err.data.message;
            }
            if (err.data.status) {
              message += " (".concat(err.data.status, ")");
            }
          }
          Logger.warn(message);
          Logger.error(err);
        });
      },
      _defaultDashboardNames: {
        'your-cards': 'Your Reports',
        'default': 'Dashboard'
      },
      _sendDashboardViewedEvent: function _sendDashboardViewedEvent(dashboardId) {
        $http({
          method: 'POST',
          url: Api.url("analytics/dashboard-view", true),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: $.param({
            boardId: dashboardId
          })
        });
      },
      dashboardViewed: function dashboardViewed(boardId) {
        if (_.isFinite(boardId)) {
          res._sendDashboardViewedEvent(boardId);
        } else {
          DefaultCardGroups.ensureExist().then(function (cardGroups) {
            //use the boardId from route param and get the appropriate dashboard from CardGroups
            var dashboard = cardGroups[res._defaultDashboardNames[boardId]];
            if (dashboard && dashboard.id) {
              res._sendDashboardViewedEvent(dashboard.id);
            }
          });
        }
      },
      settingsViewed: function settingsViewed() {
        var path = $location.path();
        path = path.replace('/settings/', '');
        $http({
          method: 'POST',
          url: Api.url("analytics/settings-view", true),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: $.param({
            tenantId: User.get().organization.id,
            page: path
          })
        });
      },
      dataViewed: function dataViewed(link) {
        var path = link.section.replace('#/data/', '');
        $http({
          method: 'POST',
          url: Api.url("analytics/data-view", true),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: $.param({
            tenantId: User.get().organization.id,
            page: path,
            display: link.display
          })
        });
      },
      helpLinkClicked: function helpLinkClicked() {
        $http({
          method: 'POST',
          url: Api.url("analytics/help-clicked", true),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: $.param({
            tenantId: User.get().organization.id,
            referrer: $location.absUrl()
          })
        });
      },
      essentialsViewed: function essentialsViewed(demo) {
        $http({
          method: 'POST',
          url: Api.url("analytics/essentials-view", true),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: $.param({
            tenantId: User.get().organization.id,
            demo: demo
          })
        });
      },
      pickerLoaded: function pickerLoaded(type, timeElapsed) {
        $http({
          method: 'POST',
          url: Api.url("analytics/picker-loaded", true),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: $.param({
            tenantId: User.get().organization.id,
            type: type,
            timeElapsed: timeElapsed
          })
        });
      },
      enabled: false,
      initialize: function initialize(user) {
        var config = Config.get();
        res.enabled = !!config.analyticsEnabled && user.user.generateAnalyticsStatements && !UserRoles.isWatershedEmployee(user);
        if (!res.enabled) {
          var deferred = $q.defer();
          deferred.resolve(false);
          return deferred.promise;
        }
        return OrganizationSettings.getForOrganization(user && user.organization && user.organization.id).then(function (response) {
          res.trackingPreference = response.trackingPreference;

          // No analytics tracking for Essentials
          if (response.pricingTier === "ESSENTIALS") {
            res.trackingPreference = "disabled";
          }
          return true;
        });
      },
      sendEvent: function sendEvent(action, properties, sync) {
        if (!res.enabled) {
          return;
        }
        sync = sync || false;
        var user = User.get();
        if (properties.statement.verb.id.indexOf("logged") > 0) {
          $http({
            method: 'POST',
            url: Api.url("analytics/session", true),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: $.param({
              tenantId: user.organization.id,
              isLogin: properties.statement.verb.id.indexOf("loggedin") > 0
            })
          });
        }
        if (this.trackingPreference !== "disabled" && properties.statement) {
          var statement = properties.statement;
          statement.context = statement.context || {};
          statement.context.contextActivities = statement.context.contextActivities || {};
          statement.context.contextActivities.grouping = statement.context.contextActivities.grouping || [];
          statement.context.contextActivities.grouping.push(res.organizationActivity());
          statement.context.contextActivities.grouping.push({
            id: Utils.qualifyURL(""),
            definition: {
              name: {
                "en-US": "Watershed LRS"
              }
            }
          });
          statement.context.contextActivities.category = statement.context.contextActivities.category || [];
          statement.context.contextActivities.category.push({
            id: "http://id.tincanapi.com/recipe/site-administration/learning-record-store/1"
          });
          statement.context.contextActivities.category.push({
            id: "http://id.tincanapi.com/activitytype/recipe"
          });
          statement.context.contextActivities.other = statement.context.contextActivities.other || [];
          var contextElement = {
            id: $window.location.href
          };
          if ($document.title) {
            contextElement.name = {
              "en-US": $document.title
            };
          }
          statement.context.contextActivities.other.push(contextElement);
          statement.context.extensions = statement.context.extensions || {};
          _.extend(statement.context.extensions, {
            "http://id.tincanapi.com/extension/location-url": $window.location.href,
            "http://id.tincanapi.com/extension/roles": [user.membership.role]
          });
          if ($document.referrer) {
            statement.context.contextActivities.other.push({
              id: $document.referrer
            });
            statement.context.extensions["http://id.tincanapi.com/extension/referrer"] = $document.referrer;
          }
          TinCanJS.sendStatement(statement);
        }
      },
      getLoggedIn: function getLoggedIn() {
        return {
          verb: {
            id: "https://brindlewaye.com/xAPITerms/verbs/loggedin/",
            display: {
              "en-US": "logged in to"
            }
          },
          target: res.organizationActivity(),
          result: {
            success: true
          },
          context: res.context()
        };
      },
      getLoggedOut: function getLoggedOut() {
        return {
          verb: {
            id: "http://id.tincanapi.com/verb/logged-out",
            display: {
              "en-US": "logged out of"
            }
          },
          target: res.organizationActivity(),
          result: {
            success: true
          },
          context: res.context()
        };
      },
      context: function context(existing, isAgentObject) {
        existing = existing || {};
        return _.extend({}, {
          registration: TinCan.Utils.getUUID(),
          platform: isAgentObject ? null : $window.navigator.userAgent,
          language: "en-US",
          contextActivities: {}
        }, existing);
      },
      organizationActivity: function organizationActivity() {
        var user = User.get();
        return {
          id: Utils.qualifyURL(Api.url()),
          definition: {
            name: {
              "en-US": user.organization.name
            }
          }
        };
      }
    };
    return res;
  }]);
})();
